import LanguageService from "./service/LanguageService";

const aLang = LanguageService.lang;

export default {
  items: [
    // {
    //   name: LanguageService.lang.nav_dsnguoidung, //string
    //   url: '/admin/user/list', //string link url
    //   icon: 'icon-user', //string class
    //   meta: {
    //     allowAccess: ['SystemAdmin'],
    //     page: 'admin'
    //   },
    // class: '',
    // wrapper: {
    //   element: '',
    //   attributes: {}
    // }
    // },LichBieuKBAT
    // {
    //   name: "Croper",
    //   url: "/admin/Croper",
    //   icon: "icon-calendar",
    //   meta: {
    //     allowAccess: ["*"],
    //     page: "admin"
    //   }
    // },
    // {
    //   name: aLang.daily_safety_data,
    //   url: "/admin/DuLieuAnToanHangNgay",
    //   icon: "icon-calendar",
    //   meta: {
    //     allowAccess: ["SafePlace"],
    //     page: "admin"
    //   }
    // },
    {
      name: aLang.tour_list,
      url: "/admin/Tour/list",
      icon: "icon-plane",
      meta: {
        allowAccess: ["Admin", "TourAgent"],
        page: "admin"
      }
    },
    {
      name: aLang.tour_ticket,
      url: "/admin/PhieuDieuTour/list",
      icon: "icon-calendar",
      meta: {
        allowAccess: ["Admin", "TourAgent", "TourGuide"],
        page: "admin"
      }
    },
    {
      name: aLang.tour_operators,
      url: "/admin/CongTyLuHanh/list",
      icon: "icon-list",
      meta: {
        allowAccess: ["Admin", "Officer", "TourAgent"],
        page: "admin"
      }
    },
    {
      name: aLang.accommodation_facility,
      url: "/admin/CoSoLuuTru/list",
      icon: "fa fa-home",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.tour_guide,
      url: "/admin/HuongDanVien/list",
      icon: "icon-people",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.tour_guide,
      url: "/admin/HuongDanVienDaDan/list",
      icon: "icon-people",
      meta: {
        allowAccess: ["TourAgent"],
        page: "admin"
      }
    },
    {
      name: aLang.tourists,
      url: "/admin/KhachDuLich/list",
      icon: "icon-user",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    // {
    //   name: "Trang điều hành",
    //   url: "/admin/TrangDieuHanh",
    //   icon: "fas fa-tachometer-alt",
    //   meta: {
    //     allowAccess: ["SVHTT"],
    //     page: "admin"
    //   }
    // },
    {
      name: "Doanh nghiệp lữ hành",
      url: "/admin/DoanhNghiepLuHanh/list",
      icon: "fas fa-bus-alt",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: "Cơ sở lưu trú",
      url: "/admin/CoSoLuuTruVHTT/list",
      icon: "fas fa-hotel",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: "Điểm đến",
      url: "/admin/DiemDen/list",
      icon: "fas fa-search-location",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: "Điểm mua sắm",
      url: "/admin/DiemMuaSam/list",
      icon: "fas fa-store",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: "Nhà hàng",
      url: "/admin/NhaHangDuLich/list",
      icon: "fas fa-utensils",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: "Vận tải",
      url: "/admin/VanTai/list",
      icon: "fas fa-taxi",
      meta: {
        allowAccess: ["SVHTT", "PVHTT"],
        page: "admin"
      }
    },
    {
      name: aLang.reflect,
      code: "PhanHoi",
      url: "/admin/PhanHoi/list",
      icon: "icon-speech",
      meta: {
        allowAccess: ["Admin", "Officer", "TourAgent", "VNATAdmin", "TCQLTT", "SVHTT", "PVHTT"],
        page: "admin"
      },
      badge: {
        variant: "danger",
        text: "0"
      }
    },

    {
      name: aLang.news,
      url: "/admin/TinTuc/list",
      icon: "icon-book-open",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.high_quality_travel_service,
      url: "/admin/DichVuChatLuongCao/list",
      icon: "icon-like",
      meta: {
        allowAccess: ["Admin", "Officer", "HqsManager", "HqsContributor"],
        page: "admin"
      }
    },
    {
      name: aLang.evaluate,
      url: "/admin/DanhGia/list",
      icon: "icon-star",
      meta: {
        allowAccess: [
          "Admin",
          "Officer",
          "TourAgent",
          "TourGuide",
          "HqsContributor",
          "HqsManager"
        ],
        page: "admin"
      }
    },
    {
      name: aLang.notification,
      url: "/admin/ThongBao/list",
      icon: "icon-bell",
      meta: {
        allowAccess: ["Admin", "Officer", "TourAgent", "SVHTT"],
        page: "admin"
      }
    },
    // {
    //     name: "Việt Nam an toàn",
    //     url: '/admin/VietNamAnToan',
    //     icon: 'fa fa-flag',
    //     meta: {
    //         allowAccess: ['Admin', 'Officer'],
    //         page: 'admin'
    //     },
    //     children: [{
    //         name: "Cảnh báo hàng ngày",
    //         url: '/admin/VietNamAnToan/CanhBaoHangNgay/list',
    //         icon: 'fa fa-caret-right',
    //         meta: {
    //             allowAccess: ['Admin', 'Officer'],
    //             page: 'admin'
    //         },
    //     }, ]
    // },

    {
      name: aLang.daily_alert,
      url: "/admin/CanhBaoHangNgay/list",
      icon: "fa fa-flag",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.program,
      url: "/admin/ChuongTrinh/list",
      icon: "fa fa-tasks",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.program_register,
      url: "/admin/DangKyChuongTrinh/list",
      icon: "fa fa-plus-circle",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.achievements_badge,
      url: "/admin/ThanhTichHuyHieu/list",
      icon: "fa fa-trophy",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.safe_destination,
      url: "/admin/DiemDenAnToan/list",
      icon: "fa fa-flag",
      meta: {
        allowAccess: ["Admin", "Officer", "VNATAdmin"],
        page: "admin"
      }
    },
    {
      name: "Quản lý merchant",
      url: "/admin/Merchant/list",
      icon: "fas fa-coins",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: "Quản lý liên kết Ngân hàng SHB",
      url: "/admin/LienKetNganHangSHB/list",
      icon: "fas fa-university",
      meta: {
        allowAccess: ["Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.safe_destination,
      url: "/admin/DangKyDDAT/list",
      icon: "fa fa-flag",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin"
      }
    },
    // {
    //   name: aLang.daily_safety_assessment,
    //   url: "/admin/DanhGiaDDATHangNgay/daily",
    //   icon: "fa fa-calendar-check-o",
    //   meta: {
    //     allowAccess: ["SafePlace"],
    //     page: "admin"
    //   }
    // },
    {
      name: aLang.checkIn_safe_destination,
      url: "/admin/CheckinDDAT/list",
      icon: "fa fa-map-marker",
      meta: {
        allowAccess: ["Admin", "Officer", "SafePlace"],
        page: "admin"
      }
    },
    {
      name: aLang.SMS_query,
      url: "/admin/TruyVanSMS",
      icon: "fas fa-sms",
      meta: {
        allowAccess: ["Officer"],
        page: "admin"
      }
    },
    // {
    //   name: aLang.epidemic_area,
    //   url: "/admin/VungDich/list",
    //   icon: "fa fa-map-o",
    //   meta: {
    //     allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
    //     page: "admin"
    //   }
    // },
    // {
    //   name: aLang.traveler_reviews,
    //   url: "/admin/DanhGiaKDL/list",
    //   icon: "icon-star",
    //   attributes: { class: "" },
    //   meta: {
    //     allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
    //     page: "admin"
    //   }
    // },
    // {
    //   name: aLang.safe_destination_rating,
    //   url: "/admin/DanhGiaDDAT/list",
    //   icon: "fa fa-check-square-o",
    //   meta: {
    //     allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
    //     page: "admin"
    //   }
    // },
    {
      name: aLang.issuing_tourist_card_code,
      url: "/admin/MsKhachDuLich/list",
      icon: "fa fa-credit-card",
      meta: {
        // allowAccess: ["Admin", "TourAgent"],
        allowAccess: ["Admin"],
        page: "admin"
      }
    },
    {
      name: aLang.Ads,
      url: "/admin/QuangCao/list",
      icon: "fab fa-buysellads",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    },
    {
      name: "Hướng dẫn sử dụng",
      url: "/admin/HDSD",
      icon: "fas fa-file-pdf",
      meta: {
        allowAccess: ["Officer"],
        page: "admin"
      }
    },
    {
      name: aLang.category,
      url: "/admin/DanhMuc",
      icon: "icon-folder",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      },
      children: [
        {
          name: aLang.review_team,
          url: "/admin/DanhMuc/NhomTPDanhGia/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Officer", "Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.reflection_group,
          url: "/admin/DanhMuc/NhomPhanHoi/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Officer", "Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.news_category,
          url: "/admin/DanhMuc/DanhMucTinTuc/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Officer", "Admin", "TourAgent"],
            page: "admin"
          }
        },
        {
          name: aLang.foreign_language,
          url: "/admin/DanhMuc/NgoaiNgu/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.nationality,
          url: "/admin/DanhMuc/QuocTich/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.forte,
          url: "/admin/DanhMuc/SoTruong/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.armorial,
          url: "/admin/DanhMuc/HuyHieu/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin"
          }
        },
        {
          name: aLang.configuration,
          url: "/admin/DanhMuc/CauHinh/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin"],
            page: "admin"
          }
        },
        {
          name: aLang.user_of_category,
          url: "/admin/DanhMuc/NguoiDung/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin"
          }
        }
      ]
    },
    {
      name: aLang.user_of_GDOMM,
      url: "/admin/NguoiDungTcqltt/list",
      icon: "fa fa-male",
      meta: {
        allowAccess: ["TCQLTTP"],
        page: "admin"
      }
    },
    {
      name: aLang.version,
      url: "/admin/PhienBan/list",
      icon: "icon-info",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin"
      }
    }
  ]
};
